// removed by extract-text-webpack-plugin
module.exports = {"Box":"_1Yjf9","BoxActive":"_3tgZU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/AddonsHeader/AddonsHeader.scss
// module id = 552
// module chunks = 0